export class Settings {
  _id: string;
  dutyAmount: number;

  constructor(obj?: Partial<Settings>) {
    this._id = obj?._id ?? 'system';
    this.dutyAmount = obj?.dutyAmount ?? 50;
  }
}
